import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const submitPilotApplication = (payload) =>
  api.post("/pilot/apply", payload).then((r) => r.data);

export const getPilotCount = () =>
  api.get("/pilot/count").then((r) => r.data);
